import { isIOS } from "react-device-detect";

export const getURLSependingOnOS = (src) => (isIOS ? src?.replace('.webm', '.mp4') : src);